import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  linkedSignal,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../../shared/services/auth.service';
import { BUTTON_LOADING_DELAY } from '../../../shared/constants/delay';
import { SessionExpiryService } from '../../services/session-expiry.service';

@Component({
  selector: 'app-extend-session-dialog',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './extend-session-dialog.component.html',
  styleUrl: './extend-session-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtendSessionDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ExtendSessionDialogComponent>);
  private readonly authService = inject(AuthService);
  private readonly sessionExpiryService = inject(SessionExpiryService);

  private actionInProgress = signal<boolean>(false);

  readonly timeRemainingFormatted = linkedSignal({
    source: this.sessionExpiryService.remainingMs,
    computation: (ms, prevTimeRemaining) => {
      const totalSeconds = Math.max(0, Math.floor(ms / 1000));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      // Don't update time remaining if action was clicked
      if (this.actionInProgress()) {
        return prevTimeRemaining?.value || '';
      }

      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    },
  });

  /** Handle extend session click */
  extendSession(): void {
    this.actionInProgress.set(true);
    this.authService.refreshSession().subscribe();
    this.dialogRef.close('extend');
    setTimeout(() => this.actionInProgress.set(false), BUTTON_LOADING_DELAY);
  }

  /** Handle logout click */
  logout(): void {
    this.actionInProgress.set(true);
    this.dialogRef.close('logout');
    setTimeout(() => this.actionInProgress.set(false), BUTTON_LOADING_DELAY);
  }
}
